import Vue from 'vue';
import Paginate from 'vuejs-paginate';
import search from '@/Modules/search/Search';

const pagination = document.getElementById('js-pagination');

const vm = pagination
  && new Vue({
    components: {
      Paginate,
    },

    delimiters: ['${', '}'],
    el: pagination,

    data() {
      return {
        info: search().info,
        currentPage: undefined,
      };
    },

    computed: {
      showPagination() {
        return this.info.PageCount;
      },
      currentPageFromStore() {
        return this.info.CurrentPage || 1;
      },
    },

    watch: {
      currentPageFromStore(newValue, oldValue) {
        this.currentPage = newValue;
      },
    },

    methods: {
      clickCallback(page) {
        this.currentPage = page;
        search().updateRequest({ pageNumber: page });
      },
    },
  });

export default vm;
